import TYPES from '../../types';

// Domain
import {
  EmergencyFundLocationRepository,
} from '@/modules/flagship/catalogs/emergency-fund-location/domain/repositories/emergency-fund-location-repository';
import {
  EmergencyFundLocationEntity,
} from '@/modules/flagship/catalogs/emergency-fund-location/domain/entities/emergency-fund-location-entity';
import {
  EmergencyFundLocationStateManager,
} from '@/modules/flagship/catalogs/emergency-fund-location/domain/state/emergency-fund-location-state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class GetEmergencyFundLocationQuery
  extends Query<Promise<Array<EmergencyFundLocationEntity>>> {
  @Inject(TYPES.EMERGENCY_FUND_LOCATION_REPOSITORY)
  private readonly repository!: EmergencyFundLocationRepository;

  @Inject(TYPES.EMERGENCY_FUND_LOCATION_STATE_MANAGER)
  private readonly state_manager!: EmergencyFundLocationStateManager;

  internalExecute(): Promise<Array<EmergencyFundLocationEntity>> {
    return new Promise((resolve, reject) => {
      if (this.state_manager.state.loaded) {
        resolve(this.state_manager.state.items);
      } else {
        this.repository.get()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      }
    });
  }
}
